export default __webpack_public_path__ + "static/media/childBackground.c71c403e.jpg";